const normalizeMediaItem = (item, index) => {
    if (!item) return null;

    if (typeof item === "string") {
        return {
            id: `media-${index}`,
            path: item,
            original_name: null,
        };
    }

    const path = item.path || item.url || item.file || "";
    if (!path) return null;

    return {
        id: item.id ?? `media-${index}`,
        path,
        original_name: item.original_name || item.name || item.title || null,
    };
};

export const getQuestionImages = (question = {}) => {
    if (Array.isArray(question.images) && question.images.length > 0) {
        return question.images.map(normalizeMediaItem).filter(Boolean);
    }

    if (question.image) {
        return [normalizeMediaItem(question.image, 0)].filter(Boolean);
    }

    return [];
};

export const getQuestionVoices = (question = {}) => {
    if (Array.isArray(question.voices) && question.voices.length > 0) {
        return question.voices.map(normalizeMediaItem).filter(Boolean);
    }

    if (question.voice) {
        return [normalizeMediaItem(question.voice, 0)].filter(Boolean);
    }

    return [];
};

export const getQuestionMediaLabel = (item, index, fallbackPrefix) => {
    if (item?.original_name) return item.original_name;
    return `${fallbackPrefix} ${index + 1}`;
};
